/* eslint import/prefer-default-export: off */
export const selectStudio = (state, studio) => (
  state['casino/studios'][studio]
);
